export function getTranslationKeyForValue(value: string): string {
  // Special handling for full uppercase values like those used for device properties
  // For example we want METAL_DETECTION_MODE_OFF to stay that way instead of being turned into Metal_detection_mode_off
  if (isEntireStringUpperCase(value)) {
    return value;
  }

  // Need some custom logic to match the way that the swagger code generator does things or else we run into issues
  // where multiple uppercase letters are right behind eachother. The AmTRx device type is a noticable example of this
  // as the generator will turn the value into amTrx instead of the expected amTRx.
  let previousWasUpper: boolean = false;
  let result: string = value.charAt(0).toUpperCase();

  for (let i: number = 1; i < value.length; i++) {
    const char: string = value.charAt(i);
    const charIsUpper: boolean = (char == char.toUpperCase());

    if (previousWasUpper && charIsUpper) {
      // Ensure multiple consecutive uppercase letters end up as one uppercase with the rest lowercase
      // abcDEFgh -> abcDefgh
      result += char.toLowerCase();
    }
    else {
      result += char;
    }

    previousWasUpper = charIsUpper;
  }
  
  return result;
}

export function isEntireStringUpperCase(value: string): boolean {
  for (let i: number = 0; i < value.length; i++) {
    const char: string = value.charAt(i);
    if (char != char.toUpperCase()) {
      return false;
    }
  }
  return true;
}